<template>
  <div class="product-list">
   <!--搜索表单-->
   <div class="common-seach-wrap">
 
     <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
       
      <el-form-item label="选择会员">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择会员</el-button>
        </el-row>
      </el-form-item>
      
  
       <el-form-item label="申请时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="searchForm.year" type="year"
             value-format="yyyy" ></el-date-picker>
          </div>
        </el-form-item>

       <el-form-item>
         <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
       
       </el-form-item>
     </el-form>
   </div>
 
  

   <div class="product-content" style="margin-top: 20px;">
      <div class="table-wrap">
        <el-table size="small" :data="tableDataa" border style="width: 100%" v-loading="loading" >
          <el-table-column prop="user.user_id" label="用户ID"></el-table-column>
         <el-table-column prop="user.nickName" label="用户"></el-table-column>
         <el-table-column prop="user.mobile" label="联系方式"></el-table-column>
          <el-table-column prop="subuser" label="总社群数量"  width="120"></el-table-column>
          <el-table-column prop="subAch" label="总业绩"  width="120"> </el-table-column>
        </el-table>
      </div>

    </div>


   <!--内容-->
   <div class="tips" style="color: red;">以下只计算订单完成的业绩</div>
   <div class="product-content" style="margin-top: 20px;">
     <div class="table-wrap">
       <el-table size="small" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" v-loading="loading"   >
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column prop="ind" label="月份" width="80"></el-table-column>

        <!-- <el-table-column prop="common_num" label="多少社群" width="90"></el-table-column> -->
        <el-table-column prop="common_sum_achi" label="社群汇总业绩" width="90"></el-table-column>

        <el-table-column prop="cond" label="条件" width="400">
          <template slot-scope="scope">
              <div class="name" v-for="(item,index) in scope.row.cond" :key="index">
                ID：{{ item.user_id }};  社群对象：{{ item.nickName }}; <span style="margin-left: 20px;">业绩：{{ item.common_sum_achi }}</span>
               </div>
           </template>
        </el-table-column>
        <el-table-column prop="common_cond" label="条件"></el-table-column>
        <el-table-column prop="fprice" label="返利金额" width="90"></el-table-column>
        <el-table-column prop="fprice" label="是否达到" >
          <template slot-scope="scope">
              <div class="name" style="font-weight: 600;font-size: 16px;">
                <p v-if="scope.row.isG > 0">已达到</p>
                <p v-else>
                  未达到
                </p>
               </div>
           </template>

        </el-table-column>
        <el-table-column prop="is_settled" label="是否结算">
          <template slot-scope="scope">
              <div class="name" style="font-weight: 600;font-size: 16px;">
                  <el-radio-group  v-model="scope.row.is_settled">
                      <el-radio  :label="1" @change="setVal(1,scope.row)">结算</el-radio>
                      <el-radio  :label="2" @change="setVal(2,scope.row)">未结算</el-radio>
                  </el-radio-group>
              </div>
          </template>
        </el-table-column>

         
       </el-table>
     </div>
   </div>



   <div class="common-seach-wrap" >
 
 <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
   
 <el-form-item label="社群奖励  ">
  
  <el-button size="small" type="primary" @click="addRewardArr" >新增社群奖励</el-button>
  <el-table :data="setting.rewardArr"  border size="mini" style="width: 100%;margin-top: 20px;">


    <el-table-column prop="name" label="奖励条件"   width="600" >
        <template v-slot="scope">
          <div class="d-s-c">
          
            <el-input style="width:200px;float: left;" type="textarea" v-model="scope.row.num"  placeholder="请输入多少社群">

            </el-input>
            <div style="float: left;margin-left: 10px;">个社群，</div>
            <div style="float: left;margin-left: 10px;">满</div>
            
            <el-input style="width: 200px;float: left;margin-left: 10px;" type="textarea" v-model="scope.row.reward"  placeholder="请输入满月销售额">

            </el-input>
            
            <div style="float: left;margin-left: 10px;">元</div>
            <div style="clear: both;"></div>
          </div>
        </template>
      </el-table-column>   
      
      
      
      <el-table-column prop="name" label="每个社群达到"   width="200" >
        <template v-slot="scope">
          <div class="d-s-c">
            <el-input style="width: 150px;" type="textarea" v-model="scope.row.eprice"  placeholder="请输入每个社群达到">

            </el-input>
            元
          </div>
        </template>
      </el-table-column>    

      <el-table-column prop="name" label="社群奖励"   width="200" >
        <template v-slot="scope">
          <div class="d-s-c">
            <el-input style="width: 150px;" type="textarea" v-model="scope.row.price"  placeholder="请输入社群奖励">

            </el-input>
            %
          </div>
        </template>
      </el-table-column>    
      
      
      
      <el-table-column prop="name" label="实际奖励"   width="200" >
        <template v-slot="scope">
          <div class="d-s-c">
            {{(scope.row.price/100 * scope.row.reward ).toFixed(2)  }}
          </div>
        </template>
      </el-table-column>  



      <el-table-column prop="name" label="操作"  width="100">
        <template v-slot="scope">
          <div style="color: blue;" @click="delRewardArr(scope.$index)">删除</div>

        </template>
      </el-table-column>
    </el-table>




  <div class="tips">1%~5%，每个直推下级代表一个社群，最高返销售额的5%</div>

  <el-button size="small" type="primary" @click="submit" >提交</el-button>
</el-form-item>

 
</el-form>


</div>



        <!--添加-->
        <GetUser :is_open="open_add"  @close="closeDialogFunc" :multi="multi"></GetUser>


 </div>
</template>

<script>
 import StatisticsApi from '@/api/statistics.js';
 import GetUser from '@/components/user/GetUser.vue';
 import qs from 'qs';
 export default{
   components:{
    GetUser
   },
   data(){
     return{
       /*是否正在加载*/
       activeName: 'type7',
       loading: true,
       tableData:[],
       /*一页多少条*/
       pageSize: 20,
       /*一共多少条数据*/
       totalDataNumber: 0,
       /*当前是第几页*/
       curPage: 1,
       /*搜索参数*/
       searchForm: {
         user_search: '',
         supply_search:"",
         year:"",
         user_id:0,
       },
       setting:{
        rewardArr:[],
       },
       /*数据对象*/
       dataModel:{},
       /*选中的*/
      multipleSelection: [],
      multi:false,
      open_add:false,
      tableDataa:[]


     }
   },
   provide: function () {
     return {
       dataModel: this.dataModel
     }
   },
   created() {

     this.getData();
     this.getSetting();
   },
   methods:{
      delRewardArr(index){
          this.setting.rewardArr.splice(index,1)
      },
      addRewardArr(){
          this.setting.rewardArr.push({
            "code":this.randomString(8,this.randomString(6,0)),
            "sort":50,
            "name":"",
          });
        },
    setVal (ind,row) {
      let self = this;
      let Params = {
        'code':'common',
        'ind':ind,
        'row':row,
      };
      StatisticsApi.setSettled(Params, true)
        .then(data => {
          self.loading = false;
          self.getData();
          
        })
        .catch(error => {});
    },  
         /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      StatisticsApi.getCSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          self.setting = data.data.vars.values;

          if(!self.setting .rewardArr){
            self.setting .rewardArr = [];
          }else{
            self.setting .rewardArr = JSON.parse(self.setting .rewardArr);
          }
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    submit() {
      let self = this;
      let params = self.setting;
      self.loading = true;
      params.rewardArr = JSON.stringify(params.rewardArr);
      StatisticsApi.saveCSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            params.rewardArr = JSON.parse(params.rewardArr);
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
      /*打开添加*/
      addClick(item) {
        this.open_add = true;
      },
          /*关闭弹窗*/
    closeDialogFunc(e, f) {
      console.log('e',e)
      if (e.type != 'error') {
          this.searchForm.user_id = e.params.user_id;
        }
        this.open_add = false;
        this.getData();
    },


     /*选择第几页*/
     handleCurrentChange(val) {
       let self = this;
       self.loading = true;
       self.curPage = val;
       self.getData();
     },

     /*每页多少条*/
     handleSizeChange(val) {
       this.pageSize = val;
       this.getData();
     },
      /*选择数据*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },


     /*搜索查询*/
     onSubmit() {
       this.curPage = 1;
       this.getData();
     },

     /*获取数据*/
     getData() {
       let self = this;
       let Params = self.searchForm;
       Params.limit =JSON.stringify({
        "page":self.curPage,
        "list_rows": self.pageSize
       }) 
       Params.type = self.activeName;
       self.loading = true;
       StatisticsApi.getCommon(Params, true)
         .then(res => {
           self.tableData = res.data.list;
           self.tableDataa =  res.data.tableDataa
          //  self.cond = res.data.cond;
           self.loading = false;
         })
         .catch(error => {});
     },
     batchExport(){//批量导出
        // 勾选需要导出的数据
        let ids = [];
      let params = this.multipleSelection;
      console.log("params",params)
      params.forEach((param)=>{
        ids.push(param.user_id);
      })
      ids = ids.join(',');
      // 筛选条件
      // 商品状态
      var parmasa =  this.searchForm?this.searchForm:{};
      console.log("parmasa",parmasa)
      parmasa["list_rows"] = this.pageSize
      parmasa["page"] = this.curPage
      if(ids.length > 0){
        // console.log(this.searchForm)
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/product.product/exportUsercommission?' + 
        qs.stringify(parmasa)+'&ids='+ids;
        
      }else{
        this.$message({
            message: '请选择要导出的数据',
            type: 'error'
          });
      }
   

    },

   }
 }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/statistics/comm/index.vue